// Portal destinations are placeholders until Cabinetry.Online confirms the live PFPC configuration.
export const PORTAL_REGISTER_URL = "https://example.com/pfpc/register"; // TODO: replace before launch
// Trade and DIY registration currently point to the same portal entry with a placeholder query flag.
// TODO: replace with the confirmed Cabinetry.Online trade and DIY sign-up destinations.
export const PORTAL_REGISTER_TRADE_URL = "https://example.com/pfpc/register?type=trade"; // TODO: replace before launch
export const PORTAL_REGISTER_DIY_URL = "https://example.com/pfpc/register?type=diy"; // TODO: replace before launch
export const PORTAL_LOGIN_URL = "https://example.com/pfpc/login"; // TODO: replace before launch
export const PORTAL_SHOP_URL = "https://example.com/pfpc/shop"; // TODO: replace before launch
export const PORTAL_SUPPORT_URL = "/help/"; // TODO: confirm whether support remains on-site

export const AUSTEN_EMAIL = "sales@pfpcabinets.com.au";
export const LOGO_URL = "https://cdn.magicpatterns.com/uploads/oQWipBCtNrzPp1H2fySft7/PFPC_Logo.png";

// Illustrative editorial imagery. Do not represent these images as PFPC facilities, staff or completed customer work.
export const IMAGE_ASSETS = {
  heroKitchen: "https://cdn.magicpatterns.com/patterns/generated-images/7d00517b-ae02-4815-bdb0-ec8d1129ae2a.jpg",
  kitchenCategory: "https://cdn.magicpatterns.com/patterns/generated-images/98cf8d2e-a7f7-48df-bf5f-ecf3f48cbee9.jpg",
  laundryCategory: "https://cdn.magicpatterns.com/patterns/generated-images/c5bb7077-e005-43eb-a6d8-1d3def2fdf89.jpg",
  wardrobeCategory: "https://cdn.magicpatterns.com/patterns/generated-images/b6776260-1136-48af-a1e4-801c1be83337.jpg",
  vanityCategory: "https://cdn.magicpatterns.com/patterns/generated-images/7f30dc93-f536-41cb-9a97-ade8310c27f8.jpg",
} as const;

export const SITE_NAVIGATION = [
  { label: "Cabinetry", href: "/cabinetry/" },
  { label: "How It Works", href: "/how-it-works/" },
  { label: "Who We Help", href: "/who-we-help/" },
  { label: "Video Guides", href: "/guides/" },
  { label: "Help", href: "/help/" },
] as const;
